import { VFlow } from 'bold-ui'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalEstabilizacaoV55() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.5.25' id='estabilizacao-5-5-25'>
        <NewsSectionContent>
          <NewsListItem>
            Inclusão do item Fornecimento de kit bucal no campo Práticas em saúde da Atividade coletiva, também
            disponível nos relatórios de produção e em seus filtros personalizados.
          </NewsListItem>
          <NewsListItem>
            Depreciação do CNS e priorização do CPF, tendo este como dado único do cidadão nas Fichas de atividade
            coletiva no CDS.
          </NewsListItem>
          <NewsListItem>
            Passa a ser permitida a inclusão de atendimentos de Escuta inicial na impressão em lote do Histórico clínico
            do cidadão, gerando um único PDF com os registros selecionados.
          </NewsListItem>
          <NewsListItem>
            Atualização da base de endereços do sistema, mantendo os dados de localidades em conformidade com a versão
            de 2026.
          </NewsListItem>
          <NewsListItem>Atualização da tabela de procedimentos SIGTAP para a competência de 06/2026.</NewsListItem>
          <NewsListItem>
            Correção de cenário em que o sistema bloqueava a importação de fichas com procedimentos de código AB em
            problemas/condições.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde atendimentos de Pré-natal, Puericultura e Puerpério realizados no CDS não
            apresentavam a devida classificação no histórico.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.24' id='estabilizacao-5-5-24'>
        <NewsSectionContent>
          <NewsListItem>
            Ajuste de erro em que alguns imóveis não estavam sendo exibidos corretamente no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível realizar a atualização do sistema em algumas instalações.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.23' id='estabilizacao-5-5-23'>
        <NewsSectionContent>
          <NewsListItem>
            Reorganização do acesso aos módulos de Cadastro individual e Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>Criação do novo perfil padrão no e-SUS com o nome Mediador intercultural.</NewsListItem>
          <NewsListItem>
            Inclusão de informações complementares dos fabricantes de vacinas para facilitar sua identificação nos
            registros de vacinação.
          </NewsListItem>
          <NewsListItem>Inclusão do campo CID-10 no módulo de Antecedentes familiares.</NewsListItem>
          <NewsListItem>Reorganização no fluxo de configuração do painel de chamadas.</NewsListItem>
          <NewsListItem>
            Atualização das regras de faixa etária e aprazamento para o registro da aplicação do imunobiológico "Pneumo
            20".
          </NewsListItem>
          <NewsListItem>
            Atualização dos campos e regras de validação para suportar o novo formato de CNPJ alfanumérico, em
            conformidade com a Instrução Normativa 2.229 da Receita Federal.
          </NewsListItem>
          <NewsListItem>
            Priorização do CPF como chave principal do cidadão no Atendimento Domiciliar e no Cadastro Domiciliar e
            Territorial do CDS, tornando o preenchimento do CNS habilitado apenas se o cidadão não possuir CPF.
          </NewsListItem>
          <NewsListItem>
            Correção de erro na Lista de atendimentos em que a equipe responsável não era carregada ao editar um
            atendimento.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
    </VFlow>
  )
}
